import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "form", "icon", "spinner"];

  initialize() {
  }

  searchPress(e) {
    if(e.keyCode == 13){
      e.preventDefault();
      this.doSearch(e);
    }
  }
  doSearch(e) {
    e.preventDefault();
    this.showLoading();
    let searchQuery = e.currentTarget.parentElement.parentElement.querySelector("input").value;
    const data = new URLSearchParams(new FormData(this.formTarget));
    fetch(this.formTarget.getAttribute("action"), {
      method: 'post',
      body: data,
      headers: {
        'X-Requested-With':'XMLHttpRequest'
      }
    })
    .then(() => {
      this.unsavedFormController.allowFormSubmission(e);
      window.location.href = `${this.element.dataset.searchPath}?search=${searchQuery}#infinite-scroll-causes`;
    })
    .catch(() => {
      this.hideLoading();
    });
  }
  showLoading() {
    if (this.hasIconTarget) this.iconTarget.style.display = "none";
    if (this.hasSpinnerTarget) this.spinnerTarget.style.display = "block";
  }
  hideLoading() {
    if (this.hasIconTarget) this.iconTarget.style.display = "";
    if (this.hasSpinnerTarget) this.spinnerTarget.style.display = "none";
  }
  get unsavedFormController() {
    return this.application.getControllerForElementAndIdentifier(document.getElementById("unsaved-changes"), "unsaved-changes");
  }
}
